<template>
    <b-col class="sag-button" :class="addClass">
        <b-button 
            v-on="$listeners"
            v-bind="$attrs"
        >
            <slot></slot>

            <div>
                {{ label }}
            </div>
            
        </b-button>
    </b-col>
</template>

<script>
import { BCol, BButton } from 'bootstrap-vue'
import { defineEmits } from '@vue/composition-api'

export default {
    components: {
        BButton,
        BCol
    },
    props: {
        label: {
            type: String,
            default: ''
        },
        addClass: {
            type: String,
            default: ''
        }
    },
    setup() {
        return {
            
        }
    }
}
</script>